export const getUserInfo = () => ({ url: 'me' })
